import React, { useState } from "react";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom"; // 1. Importar useNavigate
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import Image
import lightLogo from "../../assets/images/Avanza_Empleo.png";
import resetPasswordImage from "../../assets/images/auth/reset-password.png";

import { supabase } from "../../config/SupabaseClient";

const Actualizar = () => {
  document.title = "Avanza - Recuperar Contraseña";
  
  const navigate = useNavigate(); // 2. Inicializar navigate
  const [new_password, setNewPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const passwordValidation = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

  const ChangePassword = async (e) => {
    e.preventDefault();
    if (new_password !== confirm_password) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    
    if (!passwordValidation.test(new_password)) {
      toast.error("La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un número");
      return;
    }

    console.log("Nueva contraseña:", new_password);
    
    // Ejecutar actualización en Supabase
    await supabase.auth.updateUser({ password: new_password })
      .then(data => {
        toast.success("¡Contraseña actualizada exitosamente! Redirigiendo...");

        // 3. Temporizador para navegar a /signin después de 3 segundos
        setTimeout(() => {
          navigate("/signin");
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        console.log("Error en la actualización de contraseña:", error);
        toast.error("¡Ha ocurrido un error inesperado, comuniquese con soporte!");
      });
  };

  return (
    <React.Fragment>
      {/* El resto de tu JSX se mantiene igual */}
      <ToastContainer />
      <div className="main-content">
        <div className="page-content">
          <section className="bg-auth">
            <Container>
              <Row className="justify-content-center">
                <Col xl={10} lg={12}>
                  <Card className="auth-box">
                    <Row className="g-0">
                      <Col lg={6} className="text-center">
                        <CardBody className="p-4">
                          <Link to="/">
                            <img src={lightLogo} alt="" style={{ width: "180px" }} />
                          </Link>
                          <div className="mt-5">
                            <img src={resetPasswordImage} alt="" className="img-fluid" />
                          </div>
                        </CardBody>
                      </Col>
                      <Col lg={6}>
                        <CardBody className="auth-content p-5 h-100 text-white">
                          <div className="text-center mb-4">
                            <h5>Restablecer la contraseña</h5>
                            <p className="text-white-50">Restablece tu contraseña con Avanza Empleo.</p>
                          </div>
                          <Form className="auth-form text-white" onSubmit={ChangePassword}>
                            <p className="form-label">Nueva contraseña</p>
                            <div className="mb-3 input-group">                                
                              <Input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Contraseña"
                                required
                                value={new_password}
                                onChange={(e) => setNewPassword(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-light border"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={showPassword ? "uil uil-eye-slash" : "uil uil-eye"}></i>
                              </button>
                            </div>
                            <p className="form-label">Confirmar contraseña</p>
                            <div className="mb-5 input-group">                                
                              <Input
                                type="password"
                                className="form-control"
                                placeholder="Contraseña"
                                required
                                value={confirm_password}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                              />
                            </div>
                            <div className="mt-4">
                              <button type="submit" className="btn btn-white w-100">
                                Cambiar contraseña
                              </button>
                            </div>
                          </Form>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Actualizar;